export default __webpack_public_path__ + "static/media/Comp 2_00010.a376dad7.png";